import{defineMessages}from'react-intl';

export default defineMessages({
storeLabel:{
id:'i18n.EventFilter.storeLabel',
defaultMessage:'Store'},

brandLabel:{
id:'i18n.EventFilter.brandLabel',
defaultMessage:'Brand'},

status:{
id:'i18n.EventFilter.status',
defaultMessage:'Status'},

startDateLabel:{
id:'i18n.EventFilter.startDateLabel',
defaultMessage:'Start Date'},

endDateLabel:{
id:'i18n.EventFilter.endDateLabel',
defaultMessage:'End Date'},

moreButtonLabel:{
id:'i18n.EventFilter.moreButtonLabel',
defaultMessage:'More'},

clearAllButtonLabel:{
id:'i18n.EventFilter.clearAllButtonLabel',
defaultMessage:'Clear All'},

eventTitle:{
id:'i18n.EventFilter.eventTitle',
defaultMessage:'Event Title'},

stockLift:{
id:'i18n.EventFilter.stockLift',
defaultMessage:'S Lift'},

stockLiftFilterYes:{
id:'i18n.EventFilter.stockLiftFilterYes',
defaultMessage:'Yes'},

stockLiftFilterNo:{
id:'i18n.EventFilter.stockLiftFilterNo',
defaultMessage:'No'},

region:{
id:'i18n.EventFilter.region',
defaultMessage:'Region'},

district:{
id:'i18n.EventFilter.district',
defaultMessage:'District'},

division:{
id:'i18n.EventFilter.division',
defaultMessage:'Division'},

goal:{
id:'i18n.EventFilter.goal',
defaultMessage:'Goal'},

prepay:{
id:'i18n.EventFilter.prepay',
defaultMessage:'Prepay'},

eventType:{
id:'i18n.EventFilter.eventType',
defaultMessage:'Event Type'},

dateValidation:{
id:'i18n.EventFilter.dateValidation',
defaultMessage:'Please select valid start and end dates.'},

filterEvents:{
id:'i18n.EventFilter.filterEvents',
defaultMessage:'Filter Events'},

eventManagers:{
id:'i18n.EventFilter.eventType',
defaultMessage:'Event Managers'},

quarter:{
id:'i18n.EventFilter.quarter',
defaultMessage:'Quarter'},

deletedEvents:{
id:'i18n.EventFilter.deletedEvents',
defaultMessage:'Deleted Events'},

deletedEventsYes:{
id:'i18n.EventFilter.deletedEventsYes',
defaultMessage:'Yes'},

deletedEventsNo:{
id:'i18n.EventFilter.deletedEventsNo',
defaultMessage:'No'},

brandContact:{
id:'i18n.EventFilter.brandContact',
defaultMessage:'Brand Contact'},

dateLabel:{
id:'i18n.EventFilter.dateLabel',
defaultMessage:'Date'},

clearAllFilters:{
id:'i18n.EventFilter.clearAllFilters',
defaultMessage:'CLEAR ALL FILTERS'},

clearAllFiltersDivider:{
id:'i18n.EventFilter.clearAllFiltersDivider',
defaultMessage:'|'},

week:{
id:'i18n.EventFilter.week',
defaultMessage:'Week'},

fiscalPeriod:{
id:'i18n.EventFilter.period',
defaultMessage:'Period'},

fiscalYear:{
id:'i18n.EventFilter.year',
defaultMessage:'Year'},

categoryLabel:{
id:'i18n.EventFilter.categoryLabel',
defaultMessage:'Category'},

titleLabel:{
id:'i18n.EventFilter.titleLabel',
defaultMessage:'Title'},

eventTypeLabel:{
id:'i18n.EventFilter.eventTypeLabel',
defaultMessage:'EventType'}});
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


//////////////////
// WEBPACK FOOTER
// ./src/components/EventFilter/EventFilter.messages.js
// module id = 854
// module chunks = 0